// Auto generated file, do not manually modify!
// com.hotpads.satellite.enums.SatelliteTouringStatus

export enum SatelliteTouringStatus {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
  UNAVAILABLE = 'UNAVAILABLE',
}

export const SatelliteTouringStatus_values = [
  SatelliteTouringStatus.DISABLED,
  SatelliteTouringStatus.ENABLED,
  SatelliteTouringStatus.UNAVAILABLE,
] as const;
